var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-none flex-1 text-xl pb-2 pt-3 pr-2",class:{'cursor-pointer': _vm.pointer},on:{"click":_vm.click}},[_vm._v("\n    "+_vm._s(_vm._f("currency")(_vm.amount))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }